export const SET_UPLOADED_FILE_DIMENSIONS = "SET_UPLOADED_FILE_DIMENSIONS";
export const SET_CONTAINER_DIMENSIONS = "SET_CONTAINER_DIMENSIONS";
